import { inject } from '@angular/core';
import { Router } from '@angular/router';
import type { CanActivateFn } from '@angular/router';
import { AuthService } from '../auth/auth.service';

export const RUTA_CAMBIAR_PASSWORD = '/cambiar-password';
export const RUTA_CUENTA_ADMIN = '/admin/cuenta';

// Contraseña temporal: hasta cambiarla el backend responde 403 CAMBIO_PASSWORD_REQUERIDO en
// todo lo demás, así que se lleva directo a la pantalla de cambio.
export const cambioPasswordGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  if (auth.usuario()?.debe_cambiar_password) {
    return inject(Router).createUrlTree([RUTA_CAMBIAR_PASSWORD], { queryParams: { volver: state.url } });
  }
  return true;
};

// RN-ROL-02: el dueño siempre necesita 2FA. Sin ella, todo el panel responde 403 REQUIERE_2FA,
// así que solo puede estar en "Mi cuenta" hasta activarla.
export const segundoFactorGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  if (auth.esDueno() && !auth.usuario()?.totp_activo && !state.url.startsWith(RUTA_CUENTA_ADMIN)) {
    return inject(Router).createUrlTree([RUTA_CUENTA_ADMIN]);
  }
  return true;
};

// Login y registro: quien ya tiene sesión va directo a su panel
export const invitadoGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  return auth.autenticado() ? inject(Router).createUrlTree([auth.rutaInicio()]) : true;
};
